var amdi18n={"__root":{"OUT_OF_TRANSCRIPTION_MINUTES_WITH_COUNT":"You've used {used} of {total} transcription minutes for this period. Upgrade to keep transcribing.","OUT_OF_TRANSCRIPTION_MINUTES_GENERIC":"You've used all your transcription minutes for this period. Upgrade to keep transcribing.","UPGRADE_NOW":"Upgrade Now"},"__fr":{"OUT_OF_TRANSCRIPTION_MINUTES_WITH_COUNT":"Vous avez utilisé {used} de vos {total} minutes de transcription pour cette période. Améliorez votre abonnement pour continuer à transcrire.","OUT_OF_TRANSCRIPTION_MINUTES_GENERIC":"Vous avez utilisé toutes vos minutes de transcription pour cette période. Améliorez votre abonnement pour continuer à transcrire.","UPGRADE_NOW":"Changer votre abonnement"},"__en":{"OUT_OF_TRANSCRIPTION_MINUTES_WITH_COUNT":"You've used {used} of {total} transcription minutes for this period. Upgrade to keep transcribing.","OUT_OF_TRANSCRIPTION_MINUTES_GENERIC":"You've used all your transcription minutes for this period. Upgrade to keep transcribing.","UPGRADE_NOW":"Upgrade Now"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(typeof window !== 'undefined' && window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(typeof document !== 'undefined' && document.documentElement.lang){
				language = document.documentElement.lang;
			}else if(typeof navigator !== 'undefined' && (navigator.languages || navigator.language || navigator.userLanguage)){
				// navigator.languages does not exist in IE 11
				language = (navigator.languages && navigator.languages[0]) ||
					navigator.language ||
					navigator.userLanguage;
				language = (language || 'root').toLowerCase();
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		var recursiveFallback = function(target, source){
			for(var name in source){
				switch(typeof target[name]){
				case 'undefined':
					target[name] = source[name];
					break;
				case 'object':
					recursiveFallback(target[name], source[name]);
				}
			}
		};
		recursiveFallback(this, this.__root);
	};amdi18n.init();module.exports=amdi18n;